import React, {useEffect, useLayoutEffect} from 'react';
import type { ReactNode } from 'react';
import {
    Outlet,
    Navigate,
    ScrollRestoration,
    useLoaderData,
    useLocation,
    useRouteLoaderData
} from 'react-router-dom';
import type { LoaderFunctionArgs } from 'react-router-dom';
import { Message, ScrollTop } from './components/PrimereactComponents';
import { useTranslation } from 'react-i18next';
import { getApiClient } from './api';
import type { GeneralData, MunicipalityExtended } from './api';
import { AppContextProvider } from './context/AppContext';
import {useFooterContext} from "./layouts/AppLayout";
import { resolveMunicipalityId } from './utils/councilParams';

export const AppLoader = async ({ params }: LoaderFunctionArgs) => {
    const api = getApiClient();
    const bodyType = params.bodyType ?? '';
    const zastupitelstvoId = parseInt(params.zastupitelstvoId ?? '0', 10);
    const municipalitaId = resolveMunicipalityId(params.municipalitaId);
    return await api.getGeneralDataByMunicipalityIdAndBodyAndCouncilId(municipalitaId, bodyType, zastupitelstvoId);
};

const ScrollToTop = ({ children }: { children?: ReactNode }) => {
    const location = useLocation();
    useLayoutEffect(() => {
        document.documentElement.scrollTo(0, 0);
    }, [location.pathname]);
    return children;
};

function App() {
    const { setLatestMeetingAt, setLatestMeetingNumber, setMunicipalityTimeZone } = useFooterContext();

    const { t } = useTranslation();

    const { ready } = useTranslation();

    const municipality = useRouteLoaderData('municipality') as MunicipalityExtended;
    const basicData = useLoaderData() as GeneralData;

    if (municipality.barva !== null) {
        //root.style.setProperty('--color-primary', municipality.barva);
    }

     useEffect(() => {
         setLatestMeetingAt(basicData ? basicData.nejnovejsi_zasedani.datum : "");
         setLatestMeetingNumber(basicData ? basicData.nejnovejsi_zasedani.cislo : "");
         setMunicipalityTimeZone(municipality ? municipality.casova_zona : "")
     }, [basicData, municipality, ready, setLatestMeetingAt, setLatestMeetingNumber]);

    if (basicData !== undefined && ready) {
        if (JSON.stringify(basicData) !== '{"error":"neexistujici ID"}') {
            return (
                <>
                    <div>
                        {basicData.nejnovejsi_zasedani.cislo === undefined && (
                            <Message severity='warn' text={t('limitedDatasetWarning')} />
                        )}
                        <AppContextProvider basicData={basicData} municipalityData={municipality}>
                            <ScrollToTop />
                            <ScrollRestoration />
                            <Outlet />
                        </AppContextProvider>
                    </div>
                    <ScrollTop />
                </>
            );
        } else {
            return <Navigate to='/' />;
        }
    }
}

export default App;
